<template>
  <div class="my">
    <van-nav-bar title="我的病例" fixed left-arrow @click-left="$router.push('/my')" />
    <div class="head"><img src="@/assets/image/my/组 634@2x.png" /></div>
    <div>
      <ul v-if="caseobj.length != 0" class="my-ul">
        <li class="my-li" v-for="(item, index) in caseobj" :key="index">
          <div class="my-li-head">
            <div class="my-li-head-title">{{ item.title }}</div>
            <div class="my-li-head-title-img">
              <div class="my-li-head-title-img-1" v-if="item.status == 0"><img src="@/assets/image/my/icon/dai.png">
              </div>
              <div class="my-li-head-title-img-2" v-if="item.status == 1"><img src="@/assets/image/my/icon/tong.png">
              </div>
              <div class="my-li-head-title-img-2" v-if="item.status == 2"><img src="@/assets/image/my/icon/bo.png"></div>
            </div>
          </div>
          <div class="my-li-time">
            <div class="my-li-time-img"><img src="@/assets/image/my/icon/time.png"></div>
            <div class="my-li-time-name">{{ item.created_at }}</div>
          </div>
          <div class="my-li-box">
            <div class="my-li-box-item" @click="edit(item.id)" v-if="item.status == 0 || item.status == 2">
              <div class="my-li-box-item-img"><img src="@/assets/image/my/icon/bian.png"></div>
              <div class="my-li-box-item-name">编辑</div>
            </div>

            <div class="my-li-box-item" @click="opinion(item.reason)" v-if="item.status == 2">
              <div class="my-li-box-item-img"><img src="@/assets/image/my/icon/yi.png"></div>
              <div class="my-li-box-item-name">意见</div>
            </div>

            <div class="my-li-box-item" @click="Delete(item.id)" v-if="item.status == 0 || item.status == 2">
              <div class="my-li-box-item-img"><img src="@/assets/image/my/icon/shan.png"></div>
              <div class="my-li-box-item-name">删除</div>
            </div>

            <div class="my-li-box-item" @click="details(item.id)" v-if="item.status == 1">
              <div class="my-li-box-item-img"><img src="@/assets/image/my/icon/cha.png"></div>
              <div class="my-li-box-item-name">详情</div>
            </div>
          </div>
        </li>
      </ul>
      <van-empty v-else description="暂无数据" style="position: absolute;top: 0px;left: 50%;transform: translateX(-50%);" />
    </div>
  </div>
</template>   

<script>
export default {
  name: "myCase",
  data() {
    return {
      caseobj: []
    };
  },
  created() {
    this.getsubmitApi();
  },
  mounted() {
    // this.getsubmitApi();
  },
  methods: {
    //编辑
    edit(id) {
      this.$router.push({
        path: "/casecompile",
        query: { id }
      });
    },
    //意见
    async opinion(item) {
      // const { data: data } = await this.$http.post("auth/getReason", {
      //   id: item.id,
      // });
      this.$dialog.alert({
        title: "审核意见",
        message: item,
      });
    },
    //详情  
    details(id) {
      this.$router.push({
        path: "/casedetails",
        query: { id }
      });
    },
    //删除  
    Delete(id) {
      this.$dialog
        .confirm({
          title: "确定要删除该条病例吗？",
        })
        .then(async () => {
          const { data: data } = await this.$http.post("medical/del-case", {
            id
          });
          this.$toast(data.message);
          this.getsubmitApi();
        })
        .catch(() => { });
    },
    //获取信息
    async getsubmitApi() {
      const { data: data } = await this.$http.get(
        "medical/case",
      );
      this.caseobj = data.data
    },
  },
};
</script>
<style lang="less" scoped>
.my {
  position: relative;
  margin-bottom: 50px;


  .head {
    width: 108%;
    position: absolute;
    top: -20px;
    left: -4%;
  }

  .my-ul {
    position: relative;
    z-index: 9;
    margin-top: 15px;

    .my-li {
      box-shadow: 0px 3px 8px 1px #C5D2EF;
      border-radius: 4px 4px 4px 4px;
      padding: 16px 0 0 16px;
      background-color: #fff;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .my-li-head {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;

        .my-li-head-title {
          color: #393939;
          font-size: 14px;
          width: 230px;
        }

        .my-li-head-title-img {
          position: relative;
          top: -11px;
          left: 0;
          margin-right: 5px;

          .my-li-head-title-img-1 {
            width: 69px;
            height: 30px;
          }

          .my-li-head-title-img-2 {
            width: 80px;
            height: 30px;

          }
        }
      }

      .my-li-time {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .my-li-time-img {
          width: 14px;
          height: 14px;
          margin-right: 8px;
        }

        .my-li-time-name {
          color: #C1C3C7;
          font-size: 13px;
        }
      }

      .my-li-box {
        position: relative;
        display: flex;
        justify-content: flex-end;

        .my-li-box-item {
          position: relative;
          display: flex;
          align-items: center;
          padding: 8px;
          background-color: #F8F8F8;

          // border-right: 1px solid #DFDFDF;
          &::after {
            content: "";
            position: absolute;
            top: 8px;
            right: 0;
            width: 1px;
            height: 19px;
            background-color: #DFDFDF;
          }

          &:last-child::after {
            width: 0 !important;
          }

          .my-li-box-item-img {
            width: 13px;
            height: 13px;
            margin-right: 3px;
          }

          .my-li-box-item-name {
            color: #333333;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
<style>
.van-empty__description {
  font-size: 13px !important;
}
</style> 
